import { RootState } from '@/store/main';

export const selectLoadingContent = (state: RootState) => state.content.loadingContent;
export const selectPageNumber = (state: RootState) => state.content.pageNumber;
export const selectSearch = (state: RootState) => state.content.search;
export const selectSortBy = (state: RootState) => state.content.sortBy;
export const selectViewType = (state: RootState) => state.content.viewType;
export const selectContentMarkedForDeletion = (state: RootState) => state.content.contentMarkedForDeletion;
export const selectProjectsFilter = (state: RootState) => state.content.projectsFilter;
export const selectProductAttributesFilter = (state: RootState) => state.content.productAttributesFilter;
export const selectSelectedFileType = (state: RootState) => state.content.selectedFileType;
export const selectContentTypeToAdd = (state: RootState) => state.content.contentTypeToAdd;
export const selectProducts = (state: RootState) => state.content.products;
export const selectDocuments = (state: RootState) => state.content.documents;
export const selectUploadedVideos = (state: RootState) => state.content.uploadedVideos;
export const selectRecordings = (state: RootState) => state.content.recordings;
export const selectPendingDownloads = (state: RootState) => state.content.pendingDownloads;
export const selectUploadJobs = (state: RootState) => state.content.uploadJobs;
export const selectTemplates = (state: RootState) => state.content.templates;
export const selectFonts = (state: RootState) => state.content.fonts;
export const selectThemePacks = (state: RootState) => state.content.themePacks;
